const authModalStoragePrefix = 'growtypeFormAuthModalType:';

function getAuthModalStorageKey() {
    const path = window.location.pathname.replace(/\/$/, '');
    return authModalStoragePrefix + (path || '/');
}

function getStoredAuthModalType() {
    try {
        const type = window.sessionStorage.getItem(getAuthModalStorageKey());
        return type === 'login' || type === 'signup' ? type : null;
    } catch (error) {
        return null;
    }
}

function storeAuthModalType(type) {
    try {
        window.sessionStorage.setItem(getAuthModalStorageKey(), type);
    } catch (error) {
        // Storage can be unavailable in privacy-restricted browser contexts.
    }
}

function restoreAuthModalType() {
    const type = getStoredAuthModalType();
    const authModal = document.getElementById('growtypeFormAuthModal');

    if (!type || !authModal) {
        return;
    }

    $(authModal).find('.growtype-form-wrapper').each(function () {
        const isActive = $(this).attr('data-name') === type;
        $(this).toggleClass('is-active', isActive).toggle(isActive);
    });
}

export function formAuth() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', restoreAuthModalType);
    } else {
        restoreAuthModalType();
    }

    $(document).off('click.growtype_auth_toggle', '.growtype-form-auth .btn-link').on('click.growtype_auth_toggle', '.growtype-form-auth .btn-link', function (e) {
        const type = $(this).attr('data-type');
        if (type) {
            e.preventDefault();

            if (!type) return;

            if ($(this).closest('#growtypeFormAuthModal').length) {
                storeAuthModalType(type);
                return;
            }

            const wrapper = $(this).closest('.growtype-form-wrapper');

            // Get normalized path without trailing slash
            let path = window.location.pathname.replace(/\/$/, '');
            const search = window.location.search;

            let newPath;

            if (type === 'login') {
                wrapper.fadeOut().promise().done(function () {
                    $(this).removeClass('is-active');
                    $('.growtype-form-wrapper[data-name="login"]').fadeIn().promise().done(function () {
                        $(this).addClass('is-active');
                    });
                });

                newPath = path.replace(/\/signup$/, '/login');
                // If not already /signup, force it to /login
                if (path !== '/signup' && path !== '/signup') {
                    newPath = '/login';
                }
            }

            if (type === 'signup') {
                wrapper.fadeOut().promise().done(function () {
                    $(this).removeClass('is-active');
                    $('.growtype-form-wrapper[data-name="signup"]').fadeIn().promise().done(function () {
                        $(this).addClass('is-active');
                    });
                });

                newPath = path.replace(/\/login$/, '/signup');
                // If not already /login, force it to /signup
                if (path !== '/login' && path !== '/login') {
                    newPath = '/signup';
                }
            }

            // Re-append search/query params if they exist
            const newUrl = newPath + search;
            history.replaceState(null, '', newUrl);
        }
    });
}
